import React, { createContext, useContext, useState } from "react";
import { STEPS } from "./Utils";

const ManageWorkflowModalContext = createContext();

export const useManageWorkflowModal = () =>
  useContext(ManageWorkflowModalContext);

export const ManageWorkflowModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(STEPS.STEP_1);
  const [activeWorkflowId, setActiveWorkflowId] = useState(null);
  const [headerProps, setHeaderProps] = useState(null);

  return (
    <ManageWorkflowModalContext.Provider
      value={{
        isModalOpen,
        setIsModalOpen,
        currentStep,
        setCurrentStep,
        activeWorkflowId,
        setActiveWorkflowId,
        headerProps,
        setHeaderProps,
      }}
    >
      {children}
    </ManageWorkflowModalContext.Provider>
  );
};
